import useFocusable from '@js/mixins/focusable'
const allowedKeys = ['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'Home', 'End']

export default {
    data() {
        return {
            focusedIndex: 0,
            focusableElements: []
        }
    },
    mixins: [useFocusable],
    methods: {
        updateFocusableElements(root) {
            this.focusableElements = this.queryFocusableElements(root)
        },

        updateFocusedIndex(key) {
            this.focusedIndex = this.focusableElements.indexOf(document.activeElement)
            if (key === 'ArrowDown' || key === 'ArrowRight') {
                this.focusedIndex = this.focusedIndex + 1 >= this.focusableElements.length ? 0 : this.focusedIndex + 1
            }
            if (key === 'ArrowUp' || key === 'ArrowLeft') {
                this.focusedIndex = this.focusedIndex - 1 < 0 ? this.focusableElements.length - 1 : this.focusedIndex - 1
            }
            if (key === 'Home') {
                this.focusedIndex = 0
            }
            if (key === 'End') {
                this.focusedIndex = this.focusableElements.length - 1
            }
        },

        directionalHandler(evt, root) {
            this.updateFocusableElements(root)
            if (!allowedKeys.includes(evt.key)) { return }
            evt.preventDefault()
            evt.stopPropagation()
            this.updateFocusedIndex(evt.key)
            const newTarget = this.focusableElements[this.focusedIndex]
            newTarget.focus()
        }
    }
}